module.exports = __webpack_public_path__ + "static/media/korea.1bf5e7e5.png";